import {
    Component,
    Input,
    Output,
    EventEmitter
} from '@angular/core'
import { CommonModule } from '@angular/common'
import {
    trigger,
    transition,
    style,
    animate
} from '@angular/animations'

@Component({
    standalone: true,
    imports: [CommonModule],
    selector: 'popup-panel',
    templateUrl: './popup-panel.component.html',
    styleUrls: ['./popup-panel.component.scss'],
    animations: [
        trigger('panelSlide', [
            transition(':enter', [
                style({ opacity: 0, transform: 'translateX(-12px)' }),
                animate('200ms ease-out', style({ opacity: 1, transform: 'translateX(0)' }))
            ]),
            transition(':leave', [
                animate('150ms ease-in', style({ opacity: 0, transform: 'translateX(-12px)' }))
            ])
        ]),
        trigger('backdropFade', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('200ms ease-out', style({ opacity: 1 }))
            ]),
            transition(':leave', [
                animate('150ms ease-in', style({ opacity: 0 }))
            ])
        ])
    ]
})
export class PopupPanelComponent {
    @Input() isOpen: boolean = false
    @Input() width: string = '360px'
    @Input() panelClass: string = ''
    @Output() closed = new EventEmitter<void>()

    close() {
        this.closed.emit()
    }

    onPanelClick(event: MouseEvent) {
        event.stopPropagation()
    }
}